import { profileFields } from '@/mocks/homeData';

export default function ProfileSection() {
  return (
    <section id="profile" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-10 items-start">
          <div className="lg:col-span-2 anim-fade">
            <div className="rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=young%20Chinese%20male%20online%20content%20creator%20casual%20smart%20casual%20shirt%2C%20standing%20in%20a%20warm%20minimal%20studio%20with%20soft%20cream%20and%20coral%20backdrop%2C%20soft%20key%20lighting%2C%20editorial%20portrait%20photography%2C%20subtle%20smile%2C%20clean%20commercial%20aesthetic%2C%20high%20detail%2C%20shallow%20depth%20of%20field&width=900&height=1200&seq=portrait-main-01&orientation=portrait"
                alt="吃瓜捷克公开动态中的常见形象物料"
                title="吃瓜捷克 网络形象物料"
                className="w-full h-[340px] md:h-[420px] object-cover object-top"
              />
            </div>
            <p className="mt-2.5 text-xs text-foreground-500 flex items-start gap-1.5 leading-relaxed">
              <i className="ri-camera-line mt-0.5" aria-hidden="true"></i>
              图源为公开动态中的常见形象物料，用于帮助识别账号，非本人提供的官方照。
            </p>
          </div>

          <div className="lg:col-span-3 anim-fade" style={{ animationDelay: '0.1s' }}>
            <p className="text-xs font-medium text-primary-700 tracking-wide flex items-center gap-2">
              <span className="w-6 h-px bg-primary-300"></span>
              人物档案
            </p>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
              吃瓜捷克个人资料速查
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl">
              下面这份档案把散落在不同评论与截图里的公开信息做了一次汇总。
              每一个字段都标注了来源性质——是认证动态、网友考古，还是未经核实的说法，
              帮你把「能确认的」和「只是传的」分清楚。
            </p>

            <dl className="mt-7 divide-y divide-background-200 border-y border-background-200">
              {profileFields.map((f) => (
                <div key={f.key} className="grid grid-cols-[96px_1fr] sm:grid-cols-[120px_1fr] gap-3 py-3.5 items-baseline">
                  <dt className="text-sm text-foreground-500 whitespace-nowrap">{f.key}</dt>
                  <dd className="flex flex-col sm:flex-row sm:items-baseline sm:gap-3">
                    <span className="text-sm text-foreground-900 font-medium leading-relaxed">{f.value}</span>
                    {f.note && (
                      <span className="inline-flex items-center gap-1 text-[11px] text-secondary-800 bg-secondary-100 px-2 py-0.5 rounded-full w-fit whitespace-nowrap">
                        <i className="ri-information-line" aria-hidden="true"></i>
                        {f.note}
                      </span>
                    )}
                  </dd>
                </div>
              ))}
            </dl>

            <p className="mt-4 text-xs text-foreground-400 leading-relaxed">
              档案按公开动态定期复核。涉及年龄与真实身份的判断均属网络推测，请以本人认证账号发布的内容为准。
            </p>

            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <a
                href="#accounts"
                className="inline-flex items-center justify-center gap-1.5 text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 px-5 py-2.5 rounded-md whitespace-nowrap"
              >
                <i className="ri-external-link-line" aria-hidden="true"></i>
                去微博 / 抖音看本人
              </a>
              <a
                href="#timeline"
                className="inline-flex items-center justify-center gap-1.5 text-sm font-medium bg-background-100 text-foreground-800 border border-background-200 hover:bg-background-200 px-5 py-2.5 rounded-md whitespace-nowrap"
              >
                看网络踪迹时间线
                <i className="ri-arrow-down-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}